import Layout from '@/layout/index.vue';

export default [
  {
    path: '/appName',
    component: Layout,
    name: 'appName',
    redirect: '/appName/server',
    meta: { title: '业务系统', icon: 'el-icon-s-unfold' },
    children: [
      {
        path: 'server',
        component: () => import('@/views/appManage/layout.vue'),
        name: 'appNameServer',
        redirect: '/appName/server/retire_info',
        meta: {
          title: '服务器',
          icon: 'el-icon-s-unfold',
          alwaysShow: true, // 关键：即使只有一个子路由，也要显示
        },
        children: [
          {
            path: 'retire_info',
            name: 'retireInfo',
            component: () => import('@/views/appManage/retire_info.vue'),
            meta: { title: '收货', icon: 'el-icon-box' },
          },
        ],
      },
    ],
  },
];
